import CourseTileHolder from './CourseTileHolder';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { CoursesContext } from '../../context/CoursesContext';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import './tiles.scss';

function CourseTileContainer() {
    // Get the category parameter from the URL
    const { category } = useParams();
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

     const { coursesMap } = useContext(CoursesContext);
    
    // Format the category name for display
    const formattedCategory = decodeURIComponent(category)
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    // Fetch courses for this category
    useEffect(() => {
        setIsLoading(true);
        if (coursesMap.has(category)) {
            setCourses(coursesMap.get(category));
        }
        setIsLoading(false);
    }, [category, coursesMap]);

    // Format courses for the tile display
    const coursesForTiles = courses.map((course) => ({
        title: course.title,
        content: course.outline,
        code: course.code,
        id: course.code // Adding an id for the key prop
    }));

    // Show loading state or error if needed
    if (isLoading) {
        return (
            <div className="categories-page">
                <h1 className="green-to-red-gradient-font categories-page--heading">Loading courses...</h1>
            </div>
        );
    }

    if (error) {
        return (
            <div className="categories-page">
                <h1 className="green-to-red-gradient-font categories-page--heading">Error: {error}</h1>
            </div>
        );
    }

    return (
        <>
        <Helmet>
            <title>{formattedCategory} Courses | Watchelm</title>
            <meta name="description" content={`Explore our ${formattedCategory} courses designed to empower your team with the skills they need.`} />
        </Helmet>
        <div className="categories-page">
            <h1 className="green-to-red-gradient-font categories-page--heading">
                {formattedCategory} Courses
            </h1>
            
            <CourseTileHolder tileContents={coursesForTiles} />
        </div>
        </>
    );
}
  
  export default CourseTileContainer;